<template>
  <div>
    <van-skeleton :row="25" :loading="ske">
      <div id="class" class="shoping shop">
        <mt-header fixed title="商品详情">
          <mt-button icon="back" slot="left" @click="goBack"></mt-button>
        </mt-header>

        <mt-swipe
          style="width: 100%; height: 4rem; margin-top: 0.45rem"
          v-if="goodList.imglist != undefined && goodList.imglist.length > 0"
        >
          <mt-swipe-item v-for="(item, index) in goodList.imglist" :key="index">
            <img
              v-lazy="item.file_name"
              alt
              style="
                padding: 0px;
                height: 100%;
                width: 100%;
                object-fit: contain;
              "
            />
          </mt-swipe-item>
        </mt-swipe>
        <div class="zheko" v-if="goodList.xianshi == 1">
          <span>
            <p>限时折扣</p>
            <p>
              ￥
              <span>{{ goodList.goods_price_chn | toint }}</span>
              <span>￥{{ goodList.line_price_chn | toint }}</span>
            </p>
          </span>
         
        </div>
        <p style="font-size: 0.18rem !important">{{ goodList.goods_name }}</p>
        <p>
          <span>
            ￥{{ goodList.goods_price_chn | toint }}元
            <span>JPY￥{{ goodList.goods_price }}円</span>
          </span>
          <span @click="fenxiang(goodList)">
            <img src="../../assets/images/s1.png" alt /> 分享
          </span>
        </p>
        <p>
          <span>
            限购
            <span>每单限购{{ goodList.limits }}件</span>
          </span>
        </p>
        <p>
          <span>
            运费
            <span v-if="goodList.delivery_id == 0">包邮</span>
            <span v-if="goodList.delivery_id == 1">
              {{ ganen.mailprice | tojapan }}/箱({{
                ganen.mailnum
              }}件以内)</span
            >
          </span>
        </p>
        <p>
          <span @click="goShop(goodList, 2)">
            已选
            <span v-if="guige.length > 0 && guige[actku].spec_value != null">{{
              guige[actku].spec_value
            }}</span>
            <span>预计1-3个工作日发货</span>
          </span>
        </p>
        <p>
          <span>
            <img :src="get.imgurl" alt />
            <span>正品货源</span>
          </span>
          <span>
            <img :src="logo" alt />
            <span>日本海外仓</span>
          </span>
          <span>
            <img src="../../assets/images/zhi5.png" alt />
            <span>海关清关</span>
          </span>
          <span>
            <img src="../../assets/images/zhi4.png" alt />
            <span>顺丰配送</span>
          </span>
        </p>
        <p @click.stop="shuoshow = true">
          <span v-if="goodList.delivery_id == 1">
            <span v-for="(item, index) in ganen.goodtags" :key="index">
              <template v-if="item != '包邮'">
                <img
                  src="../../assets/images/dou1.jpg"
                  alt
                  style="width: 0.04rem"
                />
                <span style="flex: 1">{{ item }}</span>
              </template>
            </span>
          </span>
          <span v-if="goodList.delivery_id == 0">
            <span v-for="(item, index) in ganen.goodtags" :key="index">
              <img
                src="../../assets/images/dou1.jpg"
                alt
                style="width: 0.04rem"
              />
              <span style="flex: 1">{{ item }}</span>
            </span>
          </span>
          <img src="../../assets/images/enter.png" alt />
        </p>
        <div class="pric">
          <p @click="comTalk(goodList)">
            <span>商品评价({{ goodList.commentcount }})</span>
            <span v-if="goodList.lv == null">
              0%好评
              <van-icon name="arrow" />
            </span>
            <span v-else>
              {{ goodList.lv }}%好评
              <van-icon name="arrow" />
            </span>
          </p>
          <p>
            <span @click="getcomment('', goodList.id)"
              >全部评价{{ goodList.commentcount }}</span
            >
            <span @click="getcomment('好评', goodList.id)"
              >好评{{ goodList.commentcount1 }}</span
            >
            <span @click="getcomment('中评', goodList.id)"
              >中评{{ goodList.commentcount2 }}</span
            >
            <span @click="getcomment('差评', goodList.id)"
              >差评{{ goodList.commentcount3 }}</span
            >
            <span @click="getcomment('有图', goodList.id)"
              >有图评价{{ goodList.commentcount4 }}</span
            >
          </p>
          <div class="com" v-if="comobj">
            <p v-if="comobj.score1">
              <span>
                {{ comobj.nickname }}
                <el-rate v-model="comobj.score1" disabled></el-rate>
              </span>
              <span>{{ comobj.createtime | datetime }}</span>
            </p>
            <p v-if="comobj.content">{{ comobj.content }}</p>
            <p
              v-if="
                comobj.imglist != '' &&
                comobj.imglist != undefined &&
                comobj.imglist != null&&
                  comobj.imglist != '[]'
              "
            >
              <img
                v-for="(s, index) in JSON.parse(comobj.imglist)"
                :key="index"
                v-lazy="s"
                alt
              />
            </p>
              <div class="img" v-if="comobj.liuyan!=null">
                    <p>商家回复：</p>
                    <p>{{comobj.liuyan}}</p>
                </div>
          </div>
          <p>
            <span @click="comTalk(goodList)">查看全部评价</span>
          </p>
        </div>
        <div
          class="diao"
          @click="dloe(get.id)"
          v-if="get.name != null"
          style="margin: 0.1rem"
        >
          <img v-lazy="get.imgurl" alt />
          <span>
            <span>
              <p>
                <span></span>
                <span>{{ get.name }}</span>
              </p>
              <p>
                <span>{{ get.follownum }}人关注</span>
                <img src="../../assets/images/line1.png" alt />
                <span>{{ get.goodnum }}件在售商品</span>
              </p>
            </span>
            <img src="../../assets/images/enter.png" alt />
          </span>
        </div>
        <p>产品详情</p>
        <p
          style="
            font-size: 0.14rem;
            color: #323232;
            height: auto;
            padding: 0.1rem;
            line-height: 1.5;
            display: block;
            margin-bottom: 0.5rem;
          "
          v-html="goodList.content"
        ></p>

        <van-goods-action>
          <van-goods-action-icon
            icon="like-o"
            text="收藏"
            @click="collclose(goodList)"
            v-if="this.like == true"
          />
          <van-goods-action-icon
            icon="point-gift"
            text="收藏"
            @click="collclose(goodList)"
            v-if="this.like == false"
          />
          <div style="position: relative">
            <van-goods-action-icon icon="bag-o" text="购物袋" @click="cost()" />

            <span
              v-if="sum > 0"
              class="xiangimg"
              style="
                position: absolute;
                font-size: 0.09rem;
                color: white;
                background: #fc4353;
                width: 0.15rem;
                height: 0.15rem;
                line-height: 0.16rem;
                text-align: center;
                border-radius: 50%;
                top: 0px;
                right: 0.2rem;
              "
              >{{ sum }}</span
            >
          </div>
          <van-goods-action-button
            type="warning"
            text="加入购物车"
            @click="goShop(goodList, 1)"
          />
          <van-goods-action-button
            type="danger"
            text="立即购买"
            @click="goShop(goodList, 2)"
          />
        </van-goods-action>

        <van-popup v-model="show" class="fen" style="width: auto">
          <div style="margin-top: 180px;">
            <img
              :src="downloadimg"
              id="downloadimg"
              style="display: none"
              :width="width"
              :height="height"
            />
            <canvas id="drawCanvas" :width="width" :height="height"></canvas>
          </div>
        </van-popup>

        <div id="qrcode" style="display: none"></div>
        <img
          src="../../assets/images/line3.png"
          id="line3"
          style="display: none"
        />
        <img
          src="../../assets/images/di.png"
          id="tulip"
          style="display: none"
        />
        <img
          v-if="
            goodList.imglist != undefined &&
            goodList.imglist != null &&
            goodList.imglist.length != 0
          "
          :src="goodList.imglist[0].file_name"
          id="tu"
          style="display: none"
        />
        <img
          id="haha"
          v-if="
            goodList.imglist != undefined &&
            goodList.imglist != null &&
            goodList.imglist.length != 0
          "
          :src="this.imgist"
          style="display: none"
        />

        <img :src="qrImg" style="display: none" id="qrqr" />
      </div>
    </van-skeleton>

    <van-popup
      v-model="skushow"
      id="skushow"
      round
      position="bottom"
      :style="{ height: '60%' }"
    >
      <ul>
        <li v-if="guige[actku]">
          <img v-lazy="guige[actku].imgurl" alt />
          <span>
            <span>
              ￥
              <span v-if="guige[actku].goods_price_chn">{{
                guige[actku].goods_price_chn | toint
              }}</span>
            </span>
            <img src="../../assets/images/close.png" alt @click="sku" />
          </span>
        </li>
        <template style="overflow-y: scroll">
          <p></p>
          <p>
            <span
              v-for="(item, index) in guige"
              :key="index"
              @click="kucun(index)"
              :class="actku == index ? 'actku' : ''"
              >{{ item.spec_value }}</span
            >
          </p>
          <p v-if="guige[actku]">
            <span>
              数量
              <span>库存{{ guige[actku].stock_num }}件</span>
            </span>
            <span>
              <van-icon name="minus" @click="reducejie()" />
              <span>{{ this.num }}</span>
              <van-icon name="plus" @click="addjie()" />
            </span>
          </p>
        </template>

        <p>
          <mt-button v-if="this.gou == 1" @click="costMiss(guige[actku])"
            >加入购物车</mt-button
          >
          <mt-button
            v-if="this.gou == 2"
            @click="orderGo(guige[actku], goodList)"
            >立即购买</mt-button
          >
        </p>
      </ul>
    </van-popup>

    <van-popup
      v-model="shuoshow"
      id="shuoshow"
      round
      position="bottom"
      :style="{ height: '60%' }"
    >
      <p>
        <span>服务说明</span>
        <img
          src="../../assets/images/close.png"
          alt
          @click.stop="shuoshow = false"
        />
      </p>
      <ul v-for="(item, index) in fuwuData" :key="index">
        <p>
          <img src="../../assets/images/dou.jpg" alt />
          {{ item.title }}
        </p>
        <span>{{ item.name }}</span>
      </ul>
    </van-popup>
  </div>
</template>

<script>
import { Toast } from "vant";
import QRCode from "qrcodejs2";
import jquery from "jquery";
var moment = require("moment");
import { ImagePreview } from "vant";
import Bus from "@/bus.js";
import Util from "@/util.js";
export default {
  data() {
    return {
      timeData: {
        days: "",
        minutes: "",
        seconds: "",
        hours: "",
        milliseconds: "",
      },
      imgist: "",
      shuoshow: false,
      fuwuData: [
        {
          title: "假一赔十",
          name: "此商品来自日本，全链路证明可查，承诺100%正品",
        },
        { title: "包税", name: "商品售价已包含税费，无需另付税费" },
        {
          title: "包邮",
          name: "同其他商品一同结算时，只要有一件商品包邮,整单享受免运费优惠",
        },
        {
          title: "日本直邮",
          name: "本商品为日本海外仓直接发货，通过顺丰国际方式配送。",
        },
      ],
      jian: "",
      showList: false,
      coupons: [],
      gouxian: [],
      you: "",
      actku: 0,
      pinData: [],
      ske: true,
      zonglist: [],
      finished: false,
      loading: false,
      refreshing: false,
      gou: "",
      state: "",
      pinList: "",
      dlip: "",
      search: "",
      shareImg: "", // 最终生成的海报图片
      type: "",
      value: "",
      form: {},
      result: "1",
      page: 1,
      rows: 10,
      count: 0,
      commentcount: "",
      commentcount1: "",
      commentcount2: "",
      commentcount3: "",
      show: false,
      skushow: false,
      // 商品详情
      like: false,
      num: 1,
      temp: 1,
      list: {},
      checked: "",
      goodList: {
        imglist: [{}],
      },
      colltionList: [],
      total_price: "",
      id: "",
      comList: [],
      listobj: {},
      goods: [],
      userid: "",
      ganen: {},
      guige: [],
      choose: "",
      get: {},
      width: 280,
      height: 440,
      delivery: "",
      downloadimg: "",
      xiang: {},
      str: {},
      qrImg: "",
      comobj: {},
      sum: 0,
      logo: require("../../assets/images/go.png"),
    };
  },
  computed: {
    kuidi() {
      if (this.delivery != 0) {
        var sum = 0;
        var _num = 0;
        var num = this.ganen.mailnum;
        var price = this.ganen.mailprice;
        this.goods.forEach((e) => {
          _num += e.total_num;
        });
        if (_num <= 15) {
          sum = Math.floor(price);
        } else if (_num > 15) {
          if (_num % num > 0) {
            sum =
              Math.floor(_num / num) * Math.floor(price) + Math.floor(price);
          } else if (_num % num == 0) {
            sum = Math.floor(_num / num) * Math.floor(price);
          }
        }
        return sum;
      } else {
        return 0;
      }
    },
  },
  filters: {
    datetime(value) {
      //日期
      return moment(value).format("YYYY-MM-DD  HH:mm:ss");
    },
    tojapan(value) {
      var huilv = JSON.parse(localStorage.getItem("ganen")).huilv;
      console.log("fuck", huilv, value);
      return parseInt(value * parseFloat(huilv));
    },
    toint(value) {
      return parseInt(value);
    },
  },
  mounted() {
    var that = this;

    setTimeout(() => {
      var url = window.location.href.split("#")[0];
      var imgurl = "";
      if (that.goodList) {
        if (that.goodList.imglist.length > 0) {
          imgurl = that.goodList.imglist[0].file_name;
        }
      }
      var name = this.goodList.goods_name;
      $.post(this.$api.base + "/wxapi/wxconfig", { url: url }, function (data) {
        console.log("wxconfig", data);
        wx.config(data.data);
        wx.ready(function () {
          var sharedata = {
            title: localStorage.getItem("sitename"),
            desc: name,
            type: "link",
            link:
              window.location.href +
              "&mid=" +
              localStorage.getItem("mid") +
              "&type=1",
            imgUrl: imgurl,
            success: function () {},
            cancel: function () {},
          };
          wx.onMenuShareAppMessage(sharedata);
          wx.onMenuShareTimeline(sharedata);
          wx.onMenuShareQQ(sharedata);
          wx.onMenuShareQZone(sharedata);
        });
      });
    }, 1000);
  },
  async created() {
    var ss = await this.init();

    this.token = localStorage.getItem("loginMobile");
    this.userid = localStorage.getItem("user_id");

    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
    this.userid = localStorage.getItem("user_id");
    this.ganen = JSON.parse(localStorage.getItem("ganen"));
    this.ganen.goodtags = this.ganen.goodtags.split("\n");
    this.show = false;
    this.goodList = {};
    this.skushow = false;
    if (
      localStorage.getItem("appxiangqing") == "" ||
      localStorage.getItem("appxiangqing") == "null" ||
      localStorage.getItem("appxiangqing") == null ||
      localStorage.getItem("appxiangqing") == undefined
    ) {
      var str = {
        id: this.$route.query.id,
        dlip: this.$route.params.dlip,
        lie: this.$route.params.lie,
        se: this.$route.params.se,
        con: this.$route.params.con,
        pin: this.$route.params.pin,
        hot: this.$route.params.hot,
        nav: this.$route.params.nav,
      };
      var str = localStorage.setItem("appxiangqing", JSON.stringify(str));
      this.shanglist(this.$route.query.id);
    } else {
      var arr = JSON.parse(localStorage.getItem("appxiangqing"));
      if (arr.pin != undefined) {
        var id = arr.pin;
      } else {
        var id = arr.id;
      }
      if (arr.id == this.$route.query.id) {
        this.xiang = JSON.parse(localStorage.getItem("appxiangqing"));
        this.shanglist(this.xiang.id);
      } else {
        var str = {
          id: this.$route.query.id,
          dlip: this.$route.params.dlip,
          lie: this.$route.params.lie,
          se: this.$route.params.se,
          con: this.$route.params.con,
          pin: this.$route.params.pin,
          hot: this.$route.params.hot,
          nav: this.$route.params.nav,
        };
        localStorage.setItem("appxiangqing", JSON.stringify(str));
        this.xiang = JSON.parse(localStorage.getItem("appxiangqing"));
        this.shanglist(this.xiang.id);
      }
    }

    this.gouxiang();

    var sum = await Util.buycount();
    this.sum = sum;

    var mid = localStorage.getItem("mid");
    var that = this;
    if (mid) {
      this.$api.post(this.$api.base, "/wxapi/dian/view", { mid: mid }, (r) => {
        var imgurl = r.data.message.imgurl;
        that.logo = imgurl;
      });
    }
  },
  activated() {},
  methods: {
    async init() {
      return new Promise((resolve, reject) => {
        this.$api.post(this.$api.base, "/wxapi/config", {}, (r) => {
          if (r.status == 200) {
            localStorage.setItem("ganen", JSON.stringify(r.data.data));
            resolve("");
          }
        });
      });
    },
    area: function (text) {
      var replaceRegex = /(\n\r|\r\n|\r|\n)/g;
      text = text || "";
      return text.replace(replaceRegex, "<br/>");
    },
    goBack() {
      if (this.$route.query.type == "1") {
          this.$router.replace("/Index");
      } else {
        this.$router.go(-1);
      }
    },
    sku() {
      this.skushow = false;
    },
    kucun(index) {
      this.actku = index;
    },
    finish() {
      Toast("抢购已结束");
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    },
    shanglist(e) {
      var token = localStorage.getItem("loginMobile");
      this.getData(e);
      this.getcomment("", e);
      if (
        token == undefined ||
        token == "" ||
        token == null ||
        token == "null" ||
        token == "undefined"
      ) {
        this.comList = [];
        return false;
      } else {
        this.$api.post(
          this.$api.base,
          "/wxapi/collection/check",
          { token: token, goodsid: e },
          (r) => {
            if (r.data.status == 200) {
              this.like = false;
            } else if (r.data.status == 400) {
              this.like = true;
            }
          }
        );
      }
    },
    dloe(v) {
      var str = JSON.parse(localStorage.getItem("appxiangqing"));
      this.$router.push({
        name: "Tailsas",
        query: { id: v },
        params: {
          nav: str.nav,
          hot: str.hot,
          lie: str.lie,
          dlip: str.dlip,
          pin: str.id,
          se: str.se,
          con: str.con,
        },
      });
    },
    createHiDPICanvas(w, h, ratio) {
        const PIXEL_RATIO = (function () {
          const c = document.createElement("canvas"),
            ctx = c.getContext("2d"),
            dpr = window.devicePixelRatio || 1,
            bsr = ctx['webkitBackingStorePixelRatio'] ||
              ctx['mozBackingStorePixelRatio'] ||
              ctx['msBackingStorePixelRatio'] ||
              ctx['oBackingStorePixelRatio'] ||
              ctx['backingStorePixelRatio'] || 1;

          return dpr / bsr;
        })();

        if (!ratio) { ratio = PIXEL_RATIO; }
        const can = document.createElement("canvas");
        can.width = w * ratio;
        can.height = h * ratio;
        can.style.width = w + "px";
        can.style.height = h + "px";
        can.getContext("2d").setTransform(ratio, 0, 0, ratio, 0, 0);
        return can;
    },
    fenxiang(e) {
      this.show = true;
      var size = 260;
      var that = this;

      this.$api.post(
        this.$api.base,
        "/qr",
        {
          text:
            that.$api.base +
            "/dist/#/Ta?id=" +
            that.$route.query.id +
            "&mid=" +
            localStorage.getItem("mid")+"&type=1",
        },
        (r) => {
          if (r.data.status == 200) {
            this.qrImg = r.data.data;
            setTimeout(() => {
              var canvas =  that.createHiDPICanvas(280,440)
              var ctx = canvas.getContext("2d");

              var data = "";
              ctx.font = "11px '微软雅黑'";
              ctx.textAlign = "left";
              // 设置垂直对齐方式
              ctx.textBaseline = "middle";
              ctx.fillStyle = "#ffffff";

              ctx.fillRect(0, 0, that.width, that.height);
              var left = (that.width - size) / 2;
              ctx.fillStyle = "#000000";

              ctx.font = "11px";
              ctx.fillStyle = "#000000";
              ctx.lineWidth = 1;
              var titleHeight = left * 1.5; // 标题的高度
              var initHeight = left * 2; //绘制字体距离canvas顶部初始的高度
              var str = e.goods_name;
              var lineWidth = 0;
              var lastSubStrIndex = 0; //每次开始截取的字符串的索引
              for (let i = 0; i < str.length; i++) {
                lineWidth += ctx.measureText(str[i]).width;
                if (lineWidth > size) {
                  ctx.fillText(
                    str.substring(lastSubStrIndex, i),
                    left,
                    initHeight
                  ); //绘制截取部分

                  initHeight += 20;
                  lineWidth = 0;
                  lastSubStrIndex = i;
                  titleHeight += 20;
                }
                if (i == str.length - 1) {
                  //绘制剩余部分
                  ctx.fillText(
                    str.substring(lastSubStrIndex, i + 1),
                    left,
                    initHeight
                  );
                }
              }
              var arr = titleHeight + left * 2;
              ctx.font = "14px";
              ctx.fillStyle = "#fa264f";
              ctx.fillText("￥" + e.goods_price_chn, left, arr, that.width);

              var img = document.getElementById("tulip");
              ctx.drawImage(img, left, arr + left * 1.2, 10, 10);
              ctx.font = "10px";
              ctx.fillStyle = "#000000";
              ctx.fillText("正品保证", left + 15, arr + left * 1.8);
              ctx.drawImage(img, left + 100, arr + left * 1.2, 10, 10);
              ctx.font = "10px";
              ctx.fillStyle = "#000000";
              ctx.fillText("海外直邮", left + 115, arr + left * 1.8);
              ctx.drawImage(img, left + 200, arr + left * 1.2, 10, 10);
              ctx.font = "10px";
              ctx.fillStyle = "#000000";
              ctx.fillText("包税配送", left + 215, arr + left * 1.8);

              var img1 = document.getElementById("haha");
              ctx.drawImage(img1, 0, arr + left * 3, that.width, that.width);
              // var image = document.getElementById("qrcode").getElementsByTagName("img");
              // var img = image[0];

              var qrqr = document.getElementById("qrqr");
              ctx.drawImage(
                qrqr,
                left * 5,
                arr + that.width + left * 3.5,
                70,
                70
              );
              ctx.font = "12px";
              ctx.fillStyle = "#000000";
              ctx.fillText(
                "长按保存至相册",
                left * 13,
                arr + that.width + left * 6
              );
              ctx.font = "9px";
              ctx.fillStyle = "#000000";
              ctx.fillText(
                "长按识别 去逛逛",
                left * 13,
                arr + that.width + left * 8
              );

              that.downloadimg = canvas.toDataURL("image/png");
              canvas.style.display = "none";
              document.getElementById("downloadimg").style.display = "block";
            }, 200);
          }
        }
      );
    },
    // 评价
    comTalk(e) {
      var token = localStorage.getItem("loginMobile");
      if (
        token == undefined ||
        token == "" ||
        token == null ||
        token == "null" ||
        token == "undefined"
      ) {
        Toast({ message: "请先登录", position: "bottom", duration: 3000 });
      } else {
        var str = JSON.parse(localStorage.getItem("appxiangqing"));
        this.$router.push({
          name: "Tails",
          query: { id: e.id },
          params: {
            type: "商品评价",
            nav: str.nav,
            shot: str.hot,
            lie: str.lie,
            dlip: str.dlip,
            pin: str.id,
            se: str.se,
            con: str.con,
          },
        });
      }
    },

    isLogin(res) {
      if (res.data.status == 401) {
        if (
          localStorage.getItem("mid") != null &&
          localStorage.getItem("mid") != undefined &&
          localStorage.getItem("mid") != "null"
        ) {
          window.localStorage.setItem("mid", "");
          window.localStorage.setItem("user_id", null);
        }
        window.location.href = "https://www.nigilichan-go.com/wxlogin";
        return false;
      }
    },
    getcomment(v, e) {
      var arr = {
        goodsid: e,
        rows: 1,
        page: 1,
        type: v,
      };
      this.$api.post(this.$api.base, "/wxapi/goods/comment/list", arr, (r) => {
        if (r.data.status == 200) {
          this.ske = false;
          this.comList = r.data.data;
          if (r.data.data.length > 0) {
            this.comobj = r.data.data[0];
          }
        }
      });
    },
    gouxiang() {
      var token = localStorage.getItem("loginMobile");
      if (
        token == undefined ||
        token == "" ||
        token == null ||
        token == "null" ||
        token == "undefined"
      ) {
        this.gouxian = [];
        return false;
      } else {
        this.$api.post(
          this.$api.base,
          "/wxapi/shopcar/list",
          { token: token },
          (r) => {
            if (r.data.status == 200) {
              this.ske = false;
              this.gouxian = r.data.data;
            }
          }
        );
      }
    },
    // 详情
    getData(e) {
      this.$api.post(
        this.$api.base,
        "/wxapi/goods/info",
        { id: e, wxapp_id: localStorage.getItem("mid") },
        (r) => {
          if (r.data.status == 200) {
            this.ske = false;
            this.goodList = r.data.data;

            if (r.data.data.isseckill == "1") {
              this.goodList.xianshi = 1;
              this.timeData = r.data.cha;
            } else {
              this.goodList.xianshi = 0;
            }

            this.imgData(this.goodList.imglist[0].file_name);
            this.guige = r.data.data.guigelist;
            this.goodList.content = r.data.data.content;
            if (
              r.data.data.brandid != null &&
              r.data.data.brandid != undefined
            ) {
              this.getpin(r.data.data.brandid);
            }
          } else {
            setTimeout(() => {
              Toast({
                message: "当前商品已下架",
                icon: "fail",
                duration: 3000,
              });
            }, 500);
          }
        }
      );
    },
    imgData(e) {
      this.$api.post(this.$api.base, "/wxapi/getimage", { url: e }, (r) => {
        if (r.data.status == 200) {
          this.imgist = r.data.data;
        }
      });
    },
    getpin(e) {
      this.$api.post(this.$api.base, "/wxapi/category/info", { id: e }, (r) => {
        if (r.data.status == 200) {
          this.ske = false;
          this.get = r.data.data;
        }
      });
    },
    cost() {
      this.$router.push("/shopping");
    },
    goShop(e, v) {
      var token = localStorage.getItem("loginMobile");
      if (this.gowxlogin()) {
        this.skushow = true;
        if (v == 1) {
          this.gou = 1;
        } else if (v == 2) {
          this.gou = 2;
        }
      }
    },
    async costMiss(e) {
      var that = this;
      var token = localStorage.getItem("loginMobile");

      var y = await Util.checklimitadd(
        this.goodList.limits,
        this.goodList.id,
        this.num
      );
      if (y == false) {
        Toast({
          message: "当前商品限购" + this.goodList.limits + "件",
          icon: "fail",
          duration: 3000,
        });
        return;
      }

      var str = {
        token: token,
        num: this.num,
        goods_id: e.goods_id,
        goods_spec_id: e.id,
        imgurl: e.imgurl,
        goods_attr: e.spec_value,
      };
      console.log("str", str);

      this.$api.post(this.$api.base, "/wxapi/shopcar/add", str, async (r) => {
        if (r.data.status == 200) {
          this.skushow = false;
          this.gouxiang();
          setTimeout(() => {
            Toast({ message: "添加成功", icon: "success", duration: 3000 });
          }, 100);

          var sum = await Util.buycount();
          that.sum = sum;
          Bus.$emit("numindex", sum);
        } else if (r.data.status == 400) {
          setTimeout(() => {
            Toast({ message: "添加失败", icon: "fail", duration: 3000 });
          }, 100);
        } else {
          this.isLogin(r);
        }
      });
    },
    //收藏
    collclose(e) {
      if (this.gowxlogin()) {
        var token = localStorage.getItem("loginMobile");
        if (this.like == true) {
          this.$api.post(
            this.$api.base,
            "/wxapi/collection/add",
            { token: token, goodsid: e.id },
            (r) => {
              if (r.data.status == 200) {
                setTimeout(() => {
                  Toast({
                    message: "收藏成功",
                    icon: "success",
                    duration: 3000,
                  });
                }, 100);
                this.like = false;
                return false;
              } else if (r.data.status == 400) {
                setTimeout(() => {
                  Toast({ message: "收藏失败", icon: "fail", duration: 3000 });
                }, 100);
              } else {
                this.isLogin(r);
                return false;
              }
            }
          );
        } else if (this.like == false) {
          this.$api.delete(
            this.$api.base,
            "/wxapi/collection/del",
            { token: token, goodsid: e.id },
            (r) => {
              if (r.data.status == 200) {
                setTimeout(() => {
                  Toast({
                    message: "已取消收藏",
                    icon: "success",
                    duration: 3000,
                  });
                }, 100);
                this.like = true;
                return false;
              } else if (r.data.status == 400) {
                setTimeout(() => {
                  Toast({ message: "取消失败", icon: "fail", duration: 3000 });
                }, 100);
              } else {
                this.isLogin(r);
                return false;
              }
            }
          );
        }
      }
    },
    gowxlogin() {
      if (
        localStorage.getItem("loginMobile") == undefined ||
        localStorage.getItem("loginMobile") == null ||
        localStorage.getItem("loginMobile") == ""
      ) {
        window.location.href = this.$api.base + "/wxlogin";
        return false;
      } else {
        return true;
      }
    },
    reducejie() {
      if (this.num <= 1) {
        return;
      } else {
        this.num--;
      }
    },
    async addjie() {
      var stock_num = this.guige[this.actku].stock_num;
      var that = this;

      if (this.num >= stock_num) {
        setTimeout(() => {
          Toast({
            message: "库存不足",
            icon: "warning",
            duration: 3000,
          });
        }, 200);

        return;
      }

      that.num++;
    },

    // 确认1
    async orderGo(e, v) {
      var arr = [];

      console.log("e", e, v);

      console.log("判断", this.goodList.limits, this.goodList.id, this.num);

      var y = await Util.checklimitadd(
        this.goodList.limits,
        this.goodList.id,
        this.num
      );
      if (y == false) {
        Toast({
          message: "当前商品限购" + this.goodList.limits + "件",
          icon: "fail",
          duration: 3000,
        });
        return;
      }

      arr.push({
        limits: v.limits,
        goods_name: v.goods_name,
        imgurl: e.imgurl,
        goods_id: e.goods_id,
        goods_attr: e.spec_value,
        total_price: this.num * e.goods_price,
        goods_spec_id: e.id,
        total_num: this.num,
        goods_price: e.goods_price,
        price: e.goods_price_chn,
        line_price: e.line_price,
        delivery_id: v.delivery_id,
      });

      localStorage.setItem("buygoods", JSON.stringify(arr));
      this.$router.push({ name: "order", query: { type: 1 } });
    },
  },
};
</script>
<style  lang="scss" scoped>
@import "../../scss/home";
.img{
  background:#f5f5f5;
  padding:.1rem;
  margin:.1rem;
  border-radius: .05rem;
  p{
    height:auto;
  }
  p:nth-of-type(1){
    color:#333333;
    font-size:.1rem;
    font-weight:600;
  }
  p:nth-of-type(2){
    color:#aaaaaa;
    font-size:.1rem;
    margin-top:.05rem;
  }
}
</style>
